import React from 'react';
import './Loader.scss';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const Loader = ({ size = 'large', tip = 'Loading...', fullPage = false }) => {
  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: size === 'large' ? 48 : size === 'medium' ? 32 : 24,
        color: '#BFFE67', // Dark color from your theme
      }}
      spin
    />
  );

  return (
    <div className={`loader-container ${fullPage ? 'full-page' : ''}`}>
      <Spin 
        indicator={antIcon} 
        tip={tip}
        className="custom-spin"
      />
    </div>
  );
};

export default Loader;
